<template>
  <!-- Měření -->
  <v-container class="pa-0 ">
    <v-row dense no-gutters align="center" justify="center">
      <v-col class="text-body-1 ml-2">Měření</v-col>
      <v-col>
        <v-tooltip right color="info">
          <template v-slot:activator="{ on, attrs }">
            <v-avatar size="36" v-bind="attrs" v-on="on" class="float-right mx-1">
              <v-icon dark> mdi-help</v-icon>
            </v-avatar>
          </template>
          <ul>
            <li>
              Výběrem typu lze přidávat do mapy libovolné množství měřících
              objektů.
            </li>
            <li>Editace se ukončí dvojklikem.</li>
            <li>Objekty lze odstranit přes pravé tlačítko.</li>
            <li>Po vybrání myší lze objekty editovat:</li>
            <ul>
              <li>Přesouvat celý objekt.</li>
              <li>Přidávat lomové body (přes úchyt mezi body).</li>
              <li>
                Odebírat lomové body (dlouhým klikem na bod nebo klikem na
                bod s klávesou Ctrl).
              </li>
              <li>Editace se ukončí klikem mimo objekt.</li>
            </ul>
          </ul>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row dense no-gutters align="center" justify="center">
      <v-col>
        <v-chip-group class="mx-2 mb-n1" active-class="accent" column v-model="MeasureType">
          <!-- Polyline -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on">
                <v-icon>mdi-ruler</v-icon>
              </v-chip>
            </template>
            <span>Délka</span>
          </v-tooltip>
          <!-- Polygon -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip v-bind="attrs" v-on="on">
                <v-icon>mdi-ruler-square</v-icon>
              </v-chip>
            </template>
            <span>Plocha</span>
          </v-tooltip>
        </v-chip-group>
      </v-col>
    </v-row>

    <v-row dense v-if="false">
      <v-col cols="4" class="">Délka:</v-col>
      <v-col cols="7" class="accent2--text text-right">{{
        MapMeasure_SumLenght
      }}</v-col>
      <v-col cols="1" class="" v-if="false">m</v-col>
    </v-row>
    <v-row dense v-if="false">
      <v-col cols="4" class="">Plocha:</v-col>
      <v-col cols="7" class="accent2--text text-right" v-html="MapMeasure_SumARea" />
      <v-col cols="1" class="ml-0" v-if="false">m<sup>2</sup></v-col>
    </v-row>
  </v-container>
</template>

<script>
import { BasicCreateController } from "@luciad/ria/view/controller/BasicCreateController";
import { EditController } from "@luciad/ria/view/controller/EditController";
import { ShapeType } from "@luciad/ria/shape/ShapeType";

export default {
  props: {
    // Mapa
    Map: Object,
    // Mapové vrstvy
    MapLegendLayers: null,
  },

  data() {
    return {
      // Mapová vrstva název
      MeasureLayerName: "MeasureLayer",
      // Mapová vrstva měření
      MeasureLayer: null,
      // Kontroler pro nové prvky
      MapCreateController: null,
      // Kontroler pro editaci prvků
      MapEditController: null,


      // Měření - typ - Polyline/Polygon
      MeasureType: null,

      // Měření - přepínání zobrazení
      MapMeasure_view: false,

      // Měření - celková plocha
      MapMeasure_SumARea: 0,
      // Měření - celková délka
      MapMeasure_SumLenght: 0,
    };
  },

  watch: {
    MeasureType: function (value) {
      switch (value) {
        case 0:
          // Polyline
          this.MapCreateControllerCreate(ShapeType.POLYLINE);
          break;
        case 1:
          // Polygon
          this.MapCreateControllerCreate(ShapeType.POLYGON);

          break;
        default:
          // nic vybráno
          // zrušit
          // console.log("nic");
          if (this.MapCreateController != null) {
            this.MapCreateControllerDeactivated();
          }
      }
    },
  },

  methods: {
    // Vytvoření kontroleru pro nové prvky
    MapCreateControllerCreate: function (ShapeType) {
      if (this.MapCreateController != null) {
        this.MapCreateControllerDeactivated();
      }

      this.MapCreateController = new BasicCreateController(ShapeType);

      // Naslouchání události Deactivated
      const DeactivatedListener = this.MapCreateController.on(
        "Deactivated",
        this.MapCreateControllerDeactivated
      );

      // Zrušení naslouchání
      this.MapCreateController.return = function () {
        DeactivatedListener.remove();
      };

      this.MapControllerActiveChange([], [{ id: 'McMeasureFeatureCreate', contr: this.MapCreateController }])
    },

    //  Kontroler pro nové prvky - deaktivace
    MapCreateControllerDeactivated: function () {
      //console.log("MapCreateControllerDeactivated");
      this.MapCreateController.return();
      this.MapCreateController = null;
      this.MapControllerActiveChange(['McMeasureFeatureCreate'], [])
      this.MeasureType = undefined;
    },

    // Výběr objektu nad mapou pro editaci
    MapSelectionChanged: function (event) {
      // console.log(event);

      if (
        event.selectionChanges.length > 0 &&
        event.selectionChanges[0].selected.length > 0
      ) {
        const layer = event.selectionChanges[0].layer;
        const selectedFeature = event.selectionChanges[0].selected[0];

        // Pouze pro vrstvu měření
        if (layer.id == this.MeasureLayer.id) {
          // console.log("Pouze pro vrstvu měření");

          if (layer.editable && layer.visibleInTree) {
            //console.log("MapEditController")
            if (this.MapEditController != null) {
              this.MapEditControllerDeactivated();
            }

            this.MapEditController = new EditController(layer, selectedFeature, {
              finishOnSingleClick: true,
            })

            // Naslouchání události Deactivated
            const DeactivatedListener = this.MapEditController.on(
              "Deactivated",
              this.MapEditControllerDeactivated
            );

            // Zrušení naslouchání
            this.MapEditController.return = function () {
              DeactivatedListener.remove();
            };

            this.MapControllerActiveChange([], [{ id: 'McMeasureFeatureEdit', contr: this.MapEditController }])



          }
        }
      }
    },

    //  Kontroler pro editaci prvků - deaktivace
    MapEditControllerDeactivated: function () {
      //console.log("MapEditControllerDeactivated");
      this.MapEditController.return();
      this.MapEditController = null;
      this.MapControllerActiveChange(['McMeasureFeatureEdit'], [])
    },



    // Vytvoření kontextového menu pro prvky - mazání přes pravé tlačítko
    CreateContextMenu: function (contextMenu, map, contextMenuInfo) {
      const firstFeature = contextMenuInfo.objects[0];
      // console.log("contextMenu");
      contextMenu.title = "Editace objektu";
      if (firstFeature && contextMenuInfo.layer.id == this.MeasureLayer.id) {
        contextMenu.addItem({
          id: "DELETE_ID",
          label: "Odstranit",
          action: function () {
            // console.log("Odstranit objekt click");
            map.selectObjects([]);
            contextMenuInfo.layer.workingSet.remove(firstFeature.id);
          },
        });
        // console.log(contextMenu);
      }
    },

    // Přidání / odebrání mapového kontroleru
    MapControllerActiveChange: function (removeIds, addContrs) {
      this.$emit('MapControllerActiveChange', removeIds, addContrs);
    },



  },

  mounted() {
    // Inicializace
    // console.log("MapMeasure mounted");

    this.MapMeasure_view = true;

    // Vrstva s objekty měření
    this.MeasureLayer = this.MapLegendLayers.find(
      (item) => item.id == this.MeasureLayerName
    );
    this.MeasureLayer.layer.visible = true;

    // Kontextové menu nad prvkem
    this.MeasureLayer.layer.onCreateContextMenu = this.CreateContextMenu;

    // Naslouchání události SelectionChanged na mapou - výběr objektu pro editaci
    const MapSelectionChangedListener = this.Map.on(
      "SelectionChanged",
      this.MapSelectionChanged
    );

    // Zrušení naslouchání
    this.Map.return = function () {
      MapSelectionChangedListener.remove();
      // console.log("MapSelectionChangedListener - DeactivatedListener");
    };
  },

  destroyed() {
    // Zrušení
    // console.log("MapMeasure destroyed");

    this.MapMeasure_view = false;
    this.MeasureLayer.layer.visible = false;
    this.MeasureType = undefined;
    this.Map.return();

    if (this.MapCreateController != null) {
      this.MapCreateControllerDeactivated();
    }
    if (this.MapEditController != null) {
      this.MapEditControllerDeactivated();
    }

  },
};
</script>
